import React, { useState } from 'react';
import MultiVideoPlayer from './playback-video/multiVideoPlayerCctv';
import MultiVideoPlayerLive from './playback-video/liveVideoPlayerCctv';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { setActiveIndex } from '../../redux/reducers/service-reducer';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import Loader from '../loder';
import { trackEvent } from '../../mixpanel';
import { useLocation } from 'react-router-dom';

interface VideoHandlerProps {
    onTimeChange?: (e: any) => void;
    onAlarmDataChange?: (details: any) => void;
    uuid: any;
    videoPlayStatus: any;
    videoListData: any;
    lineData?: any;
    tempData?: any;
    previousApiLinesData?: any;
    rawApiLines?: any;
    apiLines?: any;
    videoData?: any;
    playVideoTime?: number;
    zoneData?: any;
    pedZoneData?: any;
    drawingMode?: "line" | "zone" | null;
    setDrawingMode?: any;
    lines?: number[][];
    setLines?: React.Dispatch<
        React.SetStateAction<number[][]>
    >;
    ttcCountData:any;
    petCountData:any;
}

const VideoHandlerCctv: React.FC<VideoHandlerProps> = React.memo(({
    onTimeChange = () => { },
    onAlarmDataChange = () => { },
    uuid,
    videoPlayStatus,
    videoListData,
    lineData,
    previousApiLinesData,
    rawApiLines,
    apiLines,
    tempData,
    videoData,
    playVideoTime,
    zoneData,
    pedZoneData,
    drawingMode,
    setDrawingMode,
    lines,
    setLines,
    ttcCountData,
    petCountData,
}) => {
    const dispatch = useDispatch()
    const [isSDCard, setSDCard] = useState(false)
    const [loading, setLoading] = useState(false)
    const { activeCarDetails, selectedDate, activeIndex } = useSelector((state: RootState) => state.service);
    const location = useLocation();
    const { userDetails } = useSelector((s: any) => s.auth.loginDetails);
    const baseButtonStyle: React.CSSProperties = {
        background: 'rgb(223, 31, 31)',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        borderTop: 'none',
        border: '1px solid #ffffff00',
        marginTop: "4px",
        float: "right",
        padding: "0px 10px 0px 10px",
        fontSize: "15px",
    };

    const handleTrackedClick = (eventName: string, button: string, action: () => void) => {
        trackEvent(eventName, {
            button,
            page: location.pathname,
            name: userDetails?.[0]?.username,
            email: userDetails?.[0]?.email,
        });
        action();
    };

    const buttons = [
        {
            label: activeCarDetails.status === "online" ? 'Live' : 'Playback',
            icon: <PlayCircleIcon style={{ color: 'red' }} />,
            onClick: () =>
                handleTrackedClick('Click on Live Video', 'Live', () =>
                    dispatch(setActiveIndex(1))
                ),
            disabled: activeCarDetails?.status !== 'online',
        }
    ];

    return (
        <>
            <Loader loading={loading} />
            <div style={{ position: 'relative', overflow: 'visible' }}>
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: '0%',
                        transform: 'translateX(-50%)',
                        zIndex: 999,
                        //display: 'flex',
                        display: "none",
                    }}
                >
                    {buttons?.map((btn, index) => {
                        const isFirst = index === 0;
                        const isLast = index === buttons.length - 1;
                        let borderRadius = '0px';
                        if (buttons.length === 1) {
                            borderRadius = '1px';
                        } else if (isFirst) {
                            borderRadius = '1px';
                        } else if (isLast) {
                            borderRadius = '1px';
                        }
                        return (
                            <Button
                                key={index}
                                color="info"
                                outline
                                disabled={btn.disabled}
                                style={{
                                    ...baseButtonStyle,
                                    borderRadius,
                                }}
                                onClick={btn.onClick}
                            >
                                {btn.label}
                            </Button>
                        );
                    })}
                </div>
                {activeIndex === 0 && (
                    <MultiVideoPlayer
                        isSDCard={isSDCard}
                        key={`${videoData}`}
                        timeFilterData={[]}
                        videoSegments={videoData}
                        onTimeChange={onTimeChange}
                        playVideoTime={playVideoTime}
                        playingStatus={videoPlayStatus}
                        lineData={lineData}
                        tempData={tempData}
                        previousApiLinesData={previousApiLinesData}
                        rawApiLines={rawApiLines}
                        apiLines={apiLines}
                        zoneData={zoneData}
                        pedZoneData={pedZoneData}
                        drawingMode={drawingMode}
                        setDrawingMode={setDrawingMode}
                        lines={lines}
                        setLines={setLines}
                        ttcCountData={ttcCountData}
                        petCountData={petCountData}
                    />
                )}
                {activeIndex === 1 && (
                    <MultiVideoPlayerLive
                        isSDCard={isSDCard}
                        key={`${videoData}`}
                        timeFilterData={[]}
                        videoSegments={videoData}
                        onTimeChange={onTimeChange}
                        playVideoTime={playVideoTime}
                    />
                )}
            </div>
        </>
    );
});

export default VideoHandlerCctv; 